import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  mapTitle: {
    padding: '0 0 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down(960)]: {
      padding: '0 16px 16px'
    }
  }
}));

export default useStyles;
